<mat-card appearance="outlined" class="milestone-card" (click)="togglePanelState()">
  <div class="project-banner">
    <img [src]="headerImageUrl" />
  </div>

  <div class="project-icon">
    <va-icon [iconName]="projectTitle" [diameter]="64" [iconUrl]="iconUrl" />
  </div>
  <div class="subtask-panel">
    <mat-accordion>
      <mat-expansion-panel [expanded]="panelState">
        <mat-expansion-panel-header>
          <mat-panel-description>
            <div class="subtask-panel-header">
              <div class="project-title">
                {{ projectTitle }}
              </div>
              <div class="project-progress">
                <mat-progress-bar mode="determinate" [value]="percentCompleted$$ | async" />
              </div>
            </div>
          </mat-panel-description>
        </mat-expansion-panel-header>

        @for (subtask of subtasks; track subtask; let i = $index) {
          <div class="row subtasks">
            <div class="col col-xs-12 subtask-container">
              <div class="subtask-icon">
                @if (subtask.status === 'Completed') {
                  <mat-icon class="subtask-completed">check</mat-icon>
                } @else {
                  <span class="subtask-incomplete">
                    {{ (i + 1).toString() }}
                  </span>
                }
              </div>
              <div class="subtask-details">
                <div class="subtask-title">{{ subtask.title }}</div>
                @switch (subtask.status) {
                  @case ('Completed') {
                    <div>Completed on {{ subtask.completionDate | date: 'longDate' }}</div>
                  }
                  @case ('In Progress') {
                    <div>
                      <span class="subtask-in-progress">In Progress</span>
                      @if (subtask.dueDate) {
                        <span>
                          - Estimated completion
                          {{ subtask.dueDate | date: 'longDate' }}
                        </span>
                      } @else {
                        <span>- Estimated completion TBD</span>
                      }
                    </div>
                  }
                  @case ('Waiting on Customer') {
                    <div>
                      <div class="subtask-waiting-on-customer">Waiting on Customer</div>
                    </div>
                  }
                  @default {
                    <div>
                      @if (subtask.dueDate) {
                        <span>
                          Estimated completion
                          {{ subtask.dueDate | date: 'longDate' }}
                        </span>
                      } @else {
                        <span>Estimated completion TBD</span>
                      }
                    </div>
                  }
                }
                @if (subtask.notes) {
                  <div class="subtask-notes">
                    <markdown [data]="subtask.notes"></markdown>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</mat-card>
